import { useEffect, useState } from 'react';

export type DeviceMode = 'mobile' | 'desktop' | 'tv';

const MOBILE_MAX = 767;

function detect(): DeviceMode {
  if (typeof window === 'undefined') return 'desktop';
  const params = new URLSearchParams(window.location.search);
  if (params.get('tv') === '1') return 'tv';
  // Auto-détection TV : large viewport + user-agent Chromecast / Android TV
  const ua = navigator.userAgent;
  if (/CrKey|GoogleTV|AndroidTV|SmartTV|AppleTV/i.test(ua)) return 'tv';
  if (window.innerWidth <= MOBILE_MAX) return 'mobile';
  return 'desktop';
}

export function useDevice(): DeviceMode {
  const [mode, setMode] = useState<DeviceMode>(detect);
  useEffect(() => {
    const onResize = () => setMode(detect());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return mode;
}

export function useIsTV(): boolean {
  return useDevice() === 'tv';
}

export function useIsMobile(): boolean {
  return useDevice() === 'mobile';
}
